<template>
  <v-layout row justify-center>
    <v-dialog v-model="showFaresDialog" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <div class="headline font-weight-bold mx-auto">
            {{ type === "new" ? "Cadastrar" : "Visualizar" }} Tarifa
          </div>
        </v-card-title>
        <v-card-text class="pt-2 pb-3">
          <div xs12 md12 class="dialog-container mx-4">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              v-if="showFaresDialog"
            >
              <v-flex xs12>
                <v-text-field
                  v-model="fare.competence"
                  label="Competência"
                  prepend-icon="event"
                  class="purple-input"
                  required
                  mask="##/####"
                  :rules="competenceRules"
                  :readonly="type === 'view'"
                />
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="fare.utility_company"
                  label="Concessionária"
                  :items="utilityCompanies"
                  :item-text="utilityCompanyText"
                  item-value="id"
                  class="purple-input"
                  :rules="[
                    (v) => !!v || 'Por favor, selecione a concessionária!',
                  ]"
                  :readonly="type === 'view'"
                  required
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="fare.kwh_value"
                  type="number"
                  label="Tarifa Energia Elétrica"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v || 'Por favor, digite a Tarifa Energia Elétrica!',
                  ]"
                  :readonly="type === 'view'"
                  @input="validateFares"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="purple"
                          size="16"
                          v-on="on"
                          incon
                          style="cursor: default"
                          class="mr-1"
                          >mdi-alert-circle-outline</v-icon
                        >
                      </template>
                      <div>
                        <p class="font-weight-bold">
                          Tarifa de energia elétrica deve ser maior do que todas
                          as outras tarifas cadastradas
                        </p>
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="fare.kwh_comp_value"
                  type="number"
                  label="Tarifa Energia Compensada s/ ICMS"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Compensada s/ ICMS!',
                  ]"
                  :readonly="type === 'view'"
                  @input="validateFares"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="purple"
                          size="16"
                          v-on="on"
                          incon
                          style="cursor: default"
                          class="mr-1"
                          >mdi-alert-circle-outline</v-icon
                        >
                      </template>
                      <div>
                        <p class="font-weight-bold">
                          Tarifa de energia compensada deve ser maior que a
                          tarifa de energia injetada HFP GD I e GD II
                        </p>
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="fare.kwh_amount_value"
                  type="number"
                  label="Tarifa Energia Injetada HFP (GD I)"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Injetada HFP (GD I)!',
                  ]"
                  :readonly="type === 'view'"
                  @input="validateFares"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="purple"
                          size="16"
                          v-on="on"
                          incon
                          style="cursor: default"
                          class="mr-1"
                          >mdi-alert-circle-outline</v-icon
                        >
                      </template>
                      <div>
                        <p class="font-weight-bold">
                          Tarifa de energia injetada HFP (GD I) deve ser maior
                          que a tarifa de energia injetada (GD II)
                        </p>
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model.number="fare.kwh_amount_value_gd2"
                  type="number"
                  label="Tarifa Energia Injetada HFP (GD II)"
                  class="purple-input"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Por favor, digite a Tarifa Energia Injetada HFP (GD II)!',
                  ]"
                  :readonly="type === 'view'"
                  @input="validateFares"
                  required
                >
                  <template v-slot:append>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          color="purple"
                          size="16"
                          v-on="on"
                          incon
                          style="cursor: default"
                          class="mr-1"
                          >mdi-alert-circle-outline</v-icon
                        >
                      </template>
                      <div>
                        <p class="font-weight-bold">
                          Tarifa de Energia injetada HFP (GD II) deve ser menor
                          do que todas outras tarifas cadastradas
                        </p>
                      </div>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn color="primary" text @click="close">Fechar</v-btn>
            <v-btn
              v-if="type === 'new'"
              :disabled="!isValid"
              color="pink darken-1"
              text
              :loading="loading"
              @click="validate"
            >
              Confirmar
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
      <v-snackbar :color="color" top v-model="snackbar" dark>
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { createTotalBillingWithFare } from "../../services/billing";
export default {
  props: {
    showFaresDialog: {
      type: Boolean,
      required: true,
    },
    import_fare: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isValid: false,
    valid: false,
    loading: false,
    fare: {
      competence: null,
      utility_company: null,
      kwh_value: null,
      kwh_comp_value: null,
      kwh_amount_value: null,
      kwh_amount_value_gd2: null,
    },
    competenceRules: [
      (v) => !!v || "Por favor, preencher a competência da fatura.",
      (v) => v?.substring(2, 6) == "2025" || "Por favor, insira o ano atual.",
      (v) =>
        (v?.substring(0, 2) >= "01" && v?.substring(0, 2) <= "12") ||
        "Por favor, o mês deve ser válido.",
    ],
    color: "",
    snackMessage: "",
    snackbar: false,
  }),

  mounted() {
    this.loading = true;
    if (this.import_fare) {
      this.fare = this.import_fare;
      const splitCompetence = this.fare?.competence.split("-");
      this.fare.competence = splitCompetence[1] + splitCompetence[0];
    }
    this.loading = false;
  },

  computed: {
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapState(["user"]),
  },

  methods: {
    ...mapActions("configuration", [
      "addFare",
      "updateFare",
      "getUtilityCompanies",
    ]),

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const data = {
          competence: this.formatCompetence(this.fare.competence),
          utility_company: this.fare.utility_company,
          kwh_value: this.fare.kwh_value,
          kwh_comp_value: this.fare.kwh_comp_value,
          kwh_amount_value: this.fare.kwh_amount_value,
          kwh_amount_value_gd2: this.fare.kwh_amount_value_gd2,
          agent_email: this.user?.email,
        };
        if (this.type === "new") {
          await this.addFare(data);
          await createTotalBillingWithFare(data);
          this.snackMessage = "Tarifa adicionada com sucesso";
          this.color = "green";
          this.closeDialog();
        }
        this.loading = false;
      } else {
        this.snackMessage = "Erro ao criar tarifa";
        this.color = "red";
        this.closeDialog();
      }
    },

    close() {
      this.showFaresDialog = false;
    },

    closeDialog() {
      this.$emit("closeDialog", this.snackMessage, this.color);
    },

    formatCompetence(competence) {
      if (competence.length === 6) {
        let year = competence.substring(2);
        let month = competence.substring(0, 2);
        return `${year}-${month}`;
      }
      return competence;
    },

    utilityCompanyText(item) {
      return `${item.name} - ${item.state}`;
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    validateFares() {
      this.isValid = true;
      if (
        this.fare.kwh_value !== null &&
        this.fare.kwh_comp_value !== null &&
        this.fare.kwh_value <= this.fare.kwh_comp_value
      ) {
        this.snack(
          "A tarifa de energia elétrica deve ser maior que a tarifa de energia compensada s/ ICMS",
          "red",
        );
        this.isValid = false;
      } else if (
        this.fare.kwh_value !== null &&
        this.fare.kwh_amount_value !== null &&
        this.fare.kwh_value <= this.fare.kwh_amount_value
      ) {
        this.snack(
          "A tarifa de energia elétrica deve ser maior que a tarifa de energia injetada HFP (GD I)",
          "red",
        );
        this.isValid = false;
      } else if (
        this.fare.kwh_value !== null &&
        this.fare.kwh_amount_value_gd2 !== null &&
        this.fare.kwh_value <= this.fare.kwh_amount_value_gd2
      ) {
        this.snack(
          "A tarifa de energia elétrica deve ser maior que a tarifa de energia injetada HFP (GD II)",
          "red",
        );
        this.isValid = false;
      } else if (
        this.fare.kwh_comp_value !== null &&
        this.fare.kwh_amount_value !== null &&
        this.fare.kwh_comp_value <= this.fare.kwh_amount_value
      ) {
        this.snack(
          "A tarifa de energia compensada deve ser maior que a tarifa de energia injetada HFP (GD I)",
          "red",
        );
        this.isValid = false;
      } else if (
        this.fare.kwh_comp_value !== null &&
        this.fare.kwh_amount_value_gd2 !== null &&
        this.fare.kwh_comp_value <= this.fare.kwh_amount_value_gd2
      ) {
        this.snack(
          "A tarifa de energia compensada deve ser maior que a tarifa de energia injetada HFP (GD II)",
          "red",
        );
        this.isValid = false;
      } else if (
        this.fare.kwh_amount_value !== null &&
        this.fare.kwh_amount_value_gd2 !== null &&
        this.fare.kwh_amount_value <= this.fare.kwh_amount_value_gd2
      ) {
        this.snack(
          "A tarifa de energia injetada HFP (GD I) deve ser maior que a tarifa de energia injetada HFP (GD II)",
          "red",
        );
        this.isValid = false;
      }
    },
  },
};
</script>
